import React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

const AddEditUserModal = ({
  showModal,
  selectedUser,
  formData,
  formErrors,
  isSubmitting,
  onClose,
  onSubmit,
  onInputChange
}) => {
  if (!showModal) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2>{selectedUser ? 'Edit User' : 'Add User'}</h2>
          <button
            className="modal-close"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <div className="modal-body">
          <form className="user-form" onSubmit={onSubmit}>
            {formErrors.submit && (
              <div className="form-error submit-error">
                {formErrors.submit}
              </div>
            )}

            <div className="form-grid">
              <TextField
                label="Name"
                name="name"
                value={formData.name}
                onChange={onInputChange}
                placeholder="Enter full name"
                required
                error={!!formErrors.name}
                helperText={formErrors.name}
              />

              <TextField
                label="Username"
                name="username"
                value={formData.username}
                onChange={onInputChange}
                placeholder="Enter username"
                required
                error={!!formErrors.username}
                helperText={formErrors.username}
              />

              <TextField
                label="Password"
                type="password"
                name="password"
                value={formData.password}
                onChange={onInputChange}
                placeholder={selectedUser ? "Leave blank to keep current password" : "Enter password"}
                error={!!formErrors.password}
                helperText={formErrors.password}
              />
            </div>

            <TextField
              label="Email"
              type="email"
              name="email"
              value={formData.email}
              onChange={onInputChange}
              placeholder="Enter email address"
              required
              error={!!formErrors.email}
              helperText={formErrors.email}
              fullWidth
            />

            <div className="form-group">
              <div className="toggle-container">
                <label className="toggle-label">
                  <span className="toggle-text">Activated</span>
                  <div className="toggle-switch">
                    <input
                      type="checkbox"
                      name="is_active"
                      checked={formData.is_active}
                      onChange={onInputChange}
                      className="toggle-input"
                    />
                    <span className="toggle-slider">
                      <span className="toggle-knob"></span>
                    </span>
                    <span className="toggle-status">{formData.is_active ? 'Yes' : 'No'}</span>
                  </div>
                </label>
              </div>
            </div>
          </form>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            onClick={onSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Saving...' : (selectedUser ? 'Update User' : 'Create User')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddEditUserModal;

